export default __webpack_public_path__ + "static/media/p-33.4f316b3c.svg";